import Nav from '../components/Nav';
import Hero from '../components/Hero';
import Marquee from '../components/Marquee';
import Problem from '../components/Problem';
import Comparison from '../components/Comparison';
import Estimator from '../components/Estimator';
import Automations from '../components/Automations';
import Portal from '../components/Portal';
import Process from '../components/Process';
import Testimonials from '../components/Testimonials';
import Pricing from '../components/Pricing';
import Credentials from '../components/Credentials';
import Contact from '../components/Contact';
import Footer from '../components/Footer';

export default function Landing() {
  return (
    <div className="bg-[#050B14] text-slate-100 min-h-screen">
      <Nav />
      <Hero />
      <Marquee />
      <Problem />
      <Comparison />
      <Estimator />
      <Automations />
      <Portal />
      <Process />
      <Testimonials />
      <Pricing />
      <Credentials />
      <Contact />
      <Footer />
    </div>
  );
}
